import "./Error.css";

const ErrorPage = () => {
  return (
    <>
      <h1>Please go to correct url Error 404 not found.</h1>
    </>
  );
};

export default ErrorPage;
